import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { EmptyVotingQuestions } from "../../models/VotingQuestions";
import { IVotingQuestions } from "../../models/VotingQuestions";
import { Form } from "./Form";
import { Table } from "./Table";
import { Answer } from "./Answer";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IVotingQuestions
}

export const VotingQuestions = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyVotingQuestions, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const [shwAddQes,setShwAddQes] = useState(false);
    const [shwUpdateQes,setShwUpdateQes] = useState(false);

    const toast = useRef<any>(null);
   
    const hideDialog = () => {
        setModal({ singleData: EmptyVotingQuestions, open: false })
    };

    useEffect(()=>{
        const sessionData = JSON.parse(sessionStorage.getItem("auth") || "");

        if(sessionData.page){
            sessionData.page.map((el:any)=>{
                if(el.pageName === "Voting Questions"){
                    if(el.is_Create >= 1){
                        setShwAddQes(true);
                    }
                    if(el.is_Update >= 1){
                        setShwUpdateQes(true);
                    }
                }
            });
        }
    },[]);
    
    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} shwAddQes={shwAddQes} shwUpdateQes={shwUpdateQes}></Table>
            <Toast ref={toast} />
        </>
    );
}
